import { AuthHeaderPortal } from "@/components";
import { ScrollManager } from "@/components/ui";
import { Outlet, useLocation } from "react-router-dom";

export function AuthLayout() {
  const location = useLocation();
  const isOnboardingRoute = location.pathname.includes("/auth/onboarding");
  const isSubscriptionStep =
    location.pathname === "/auth/onboarding/subscription";

  // Onboarding pages have their own full-page layout, render directly
  if (isOnboardingRoute) {
    return (
      <>
        <ScrollManager />
        <Outlet />
      </>
    );
  }

  return (
    <>
      <ScrollManager />
      {/* Main Auth Layout - full width single column */}
      <div className="min-h-screen">
        <div className="flex flex-col gap-4 p-6 md:p-10">
          <AuthHeaderPortal />
          <div
            className={`flex flex-1 items-start justify-center pt-20`}
          >
            <div className="w-full max-w-sm">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthLayout;
